import { FiMail } from 'react-icons/fi';
import { FaGithub, FaLinkedin } from 'react-icons/fa';

const contacts = [
    {
        icon: FiMail,
        label: 'raghul1998@gmail.com',
        href: 'mailto:raghul1998@gmail.com',
        hoverColor: 'hover:text-[#f0883e]',
    },
    {
        icon: FaGithub,
        label: 'github.com/raghul1998',
        href: 'https://github.com/raghul1998',
        hoverColor: 'hover:text-[#3fb950]',
    },
    {
        icon: FaLinkedin,
        label: 'linkedin.com/in/s-raghul',
        href: 'https://linkedin.com/in/s-raghul/',
        hoverColor: 'hover:text-[#58a6ff]',
    },
];

export default function Contact() {
    return (
        <section id="contact" className="px-6 py-24 bg-[#161b22]" data-aos="fade-up">
            <div className="max-w-3xl mx-auto">
                <p className="text-[#f0883e] text-xs mb-2 font-mono tracking-widest uppercase">
                    {'// contact.sh'}
                </p>
                <h2 className="text-2xl font-bold text-[#e6edf3] mb-3 font-mono">Let's Connect</h2>
                <p className="text-[#8b949e] text-sm mb-10 font-mono">
                    I'm always open to discussing new projects or opportunities.
                </p>

                <div className="font-mono text-sm mb-8 flex items-center gap-2">
                    <span className="text-[#58a6ff]">$</span>
                    <span className="text-[#8b949e]">echo $CONTACT</span>
                </div>

                <div className="flex flex-col sm:flex-row gap-8 sm:gap-12">
                    {contacts.map(({ icon: Icon, label, href, hoverColor }) => (
                        <a
                            key={href}
                            href={href}
                            target={href.startsWith('http') ? '_blank' : undefined}
                            rel="noopener noreferrer"
                            className={`flex flex-col items-start sm:items-center gap-3 text-[#8b949e] ${hoverColor} transition-colors duration-200 group`}
                        >
                            <Icon className="text-2xl" />
                            <span className="text-xs font-mono group-hover:underline underline-offset-4">
                                {label}
                            </span>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
